module.exports = __webpack_public_path__ + "static/media/shoushan_plant.16a1a22f.webp";